<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @input="dialogStateChanged"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        x-small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="ml-1" x-small>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Describe the Decision</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Description"
                v-model="newDescription"
                :error-messages="nameErrors"
                filled
                auto-grow
                placeholder="Give a more detailed description of the Decision"
                @input="$v.newDescription.$touch()"
                @blur="$v.newDescription.$touch()"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="handleCancel" :disabled="saving">Cancel</v-btn>
        <v-btn color="primary" :disabled="$v.newDescription.$invalid" :loading="saving" @click="handleConfirm">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { maxLength } from 'vuelidate/lib/validators'

// Veux types
import * as DecisionsTypes from '../store/types/decisions'

export default {
  name: 'EditDecisionNameDialog',
  mixins: [validationMixin],
  validations: {
    newDescription: { maxLength: maxLength(400) }
  },
  props: {
    value: String,
    decisionId: String
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.newDescription.$dirty) return errors
      !this.$v.newDescription.maxLength && errors.push('The descriptoin must be at most 400 characters long')
      return errors
    },
    newDescription: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  data () {
    return {
      dialog: false,
      oldDescription: '',
      saving: false
    }
  },
  methods: {
    handleConfirm: async function () {
      // Save the name change
      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewNameURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}`
      const postNameBody = {description: this.newDescription}
      this.saving = true

      await axios.post(postNewNameURL, postNameBody, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })
      this.saving = false
      this.dialog = false

      // Update the vuex store with the changes
      // Update the modified property in the main decision list
      this.$store.commit(`decisions/${DecisionsTypes.MUTATION_UPDATE_DECISION}`, {
        id: this.decisionId,
        updates: {
          description: this.newDescription
        }
      })
    },
    handleCancel: function () {
      this.newDescription = this.oldDescription
      this.dialog = false
    },
    dialogStateChanged: function () {
      this.oldDescription = this.value
      this.$v.$reset()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
